<template>
  <div class="zixun">
    <div class="top">
      <h2>类型：</h2>
      <span>文章</span>
    </div>
    <Item
      class="bottom"
      v-for="item in itemList1"
      :key="item.id"
      :curcer="item.articleId"
      :every="item"
      @itemClick="goDetail"
    ></Item>
    <Paging
      :total="total"
      :curPage="curPage"
      :limit="limit"
      :showPage="5"
      @changePager="handlePager"
    ></Paging>
  </div>
</template>

<script>
import Item from "./Item.vue";
import Paging from "@/components/paging";
export default {
  components: {
    Item,
    Paging,
  },
  data() {
    return {
      itemList1: [], // 咨询列表
      // 分页
      curPage: 1,
      total: 0,
      limit: 0,
    };
  },
  created() {
    this.getUserCollectInformationList();
  },
  methods: {
    handlePager(newPage) {
      this.curPage = newPage;
      this.getUserCollectInformationList({
        pageNo: newPage,
      });
      document.documentElement.scrollTop = 0;
    },
    // 咨询列表
    async getUserCollectInformationList(data) {
      const resp = await this.$apis.userServe.getUserCollectInformationList(
        data
      );
      if (resp.data) {
        this.total = +resp.data.total;
        this.limit = +resp.data.pageSize;
        this.itemList1 = resp.data.list;
      }
    },
    goDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "/msgDetails",
        query: {
          type: e.articleType,
          id: e.articleId,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.zixun {
  width: 1200px;
  .bottom {
    background-color: #fff;
    padding: 37px 49px 19px 37px;
  }
  .top {
    display: flex;
    margin: 40px 0;
    h2 {
      vertical-align: middle;
      font-size: 14px;
      color: #333;
      font-weight: 400;
    }
    span {
      color: #0101f3;
      margin: 0 10px;
      cursor: pointer;
    }
  }
}
</style>
